// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__208G2","colBig":"styles_colBig__UHvKq","colSmall":"styles_colSmall__2UnZa"};